import React from "react";

const RequestUser = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
              d="M28.684 2H6.65C4.637 2 3 3.617 3 5.57v17.92c0 1.988 1.637 3.605 3.65 3.605h6.242l2.933 5.793c.75 1.483 2.9 1.483 3.65 0l2.967-5.793h6.276c1.978 0 3.615-1.617 3.615-3.604V5.57c0-1.954-1.637-3.571-3.65-3.571ZM17.667 6.85c1.944 0 3.547 1.55 3.547 3.504 0 1.92-1.57 3.503-3.547 3.503-1.979 0-3.513-1.55-3.513-3.503a3.493 3.493 0 0 1 3.513-3.503ZM12.619 17.9a3.736 3.736 0 0 1 2.251-2.965c.819.471 1.74.774 2.763.774s1.944-.303 2.762-.774c1.194.505 2.115 1.583 2.252 2.964l.375 3.031c.034.405-.205.775-.614.843-1.5.303-3.138.505-4.81.505-1.67 0-3.274-.169-4.809-.505-.375-.068-.648-.438-.614-.843l.444-3.03Z"
              fill={fill}
        />
    </svg>
);

export default RequestUser;